module.exports = __webpack_public_path__ + "static/img/shushi-4.d5256962.png";